function Footer() {
  return <div className='footer_title'>© 2024 MERLINX</div>;
}

export default Footer;
